import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { KnowledgeSubDomainType } from "../../../types/KnowledgeDomain";

const initialState: KnowledgeSubDomainType = {
    id: "",
    description: "",
    code: "",
    idDomain: "",
    status: false
};

export const knowledgeSubDomainSlice = createSlice({
    name: "knowledgeSubDomainForm",
    initialState,
    reducers: {
        setKnowledgeSubDomainData: (
            state, action: PayloadAction<KnowledgeSubDomainType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetKnowledgeSubDomainData: () => {
            return initialState;
        }
    }
});

export const { setKnowledgeSubDomainData, resetKnowledgeSubDomainData } = knowledgeSubDomainSlice.actions;
export default knowledgeSubDomainSlice.reducer;
